import { ReactSVG } from 'react-svg';
import { RowView } from '../../components';
import AuthWrapper from '../../components/AuthWrapper';
import LinkedAccountsFunctional from './index.function';
import Text from '../../components/Text';
import { fontSizes } from '../../constants/constants';
import Loader from '../../components/Loader';
import ViewItems from '../../components/ViewItems';
import Button from '../../components/Button';
import images from '../../constants/images';
import Language from '../../components/Language';
import AccountCard from '../../components/AccountCard';

const LinkedAccounts = () => {
  const {
    isArabic,
    direction,
    TextWeight,
    applications,
    authLoading,
    onPressApplication,
    user,
    getContentKey
  } = LinkedAccountsFunctional();

  return (
    <AuthWrapper>
      <div className='w-full'>
        <RowView className='justify-between items-center'>
          <img src={images.textLogo} width={70} />
          <div className="flex justify-end">
            <Language isLogin />
          </div>
        </RowView>

        <Text
          text={getContentKey('linked_account_heading')}
          align={isArabic ? 'text-right' : 'text-left'}
          weight={TextWeight.semiBold}
          size={fontSizes.h18}
          className={'block mt-2'}
        />
        <div dir={direction} className='max-h-[450px] overflow-auto mt-4 space-y-4'>
          <AccountCard
            data={user?.linkedAccounts}
            isPending={true}
            onPressApplication={onPressApplication}
          />
        </div>
      </div>
    </AuthWrapper>
  );
};

export default LinkedAccounts;
